import { useEffect, useRef, useTransition } from 'react';
import { useNavigate } from 'react-router-dom';

import { manualCreate } from '~modules/journal/api';
import { addStore } from '~pages/manager/SessionAdd/add-store.ts';
import { getFileFromBase64 } from '~shared/helpers';
import { routerKeys } from '~shared/router';
import { toastError, toastSuccess } from '~shared/ui';

export function useAddSession() {
	const {
		user,
		setUser,
		photo,
		setPhoto,
		clearPhoto,
		errors,
		clearErrors,
		setError,
		clear,
		is_part_time,
		setPartTime,
	} = addStore();
	const [pending, startSaving] = useTransition();
	const navigate = useNavigate();
	const isFirstRender = useRef(true);

	useEffect(() => {
		if (isFirstRender.current) {
			isFirstRender.current = false;
			clear();
		}
	}, [clear]);

	async function create() {
		startSaving(async () => {
			clearErrors();
			let isError = false;
			if (!user) {
				setError('user', 'Необходимо выбрать сотрудника');
				isError = true;
			}
			if (!photo) {
				setError('photo', 'Необходимо добавить фото сотрудника');
				isError = true;
			}
			if (!isError) {
				try {
					const file = getFileFromBase64(photo!, 'photo.jpg');
					await manualCreate(user!.id!, file, is_part_time);
					toastSuccess('Данные успешно сохранены');
					clear();
					navigate(routerKeys.manager.root());
				} catch (err) {
					console.error(err);
					toastError('Ошибка сохранения данных');
				}
			} else {
				toastError('Не все поля заполнены');
			}
		});
	}

	return {
		pending,
		user,
		setUser,
		photo,
		setPhoto,
		clearErrors,
		clearPhoto,
		errors,
		setError,
		create,
		is_part_time,
		setPartTime,
	};
}
